





















import { TbMember, TbReturnOrder } from '@/http';
import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
import { fmoney } from '@/common/money';
import calculate from '@/common/util/calculate';
import { dialogPanel } from "@/components";
@Component({
    components: {
        dialogPanel
    },
})
export default class remarkPanel extends Vue {
    public $refs: {
    };
    show=false;
    value="";

    created() {
    }   
    
    mounted() {
       
    }
    showFun(val){
        this.value = val;
        this.show = true;
    }
    closeFun(){
        this.show = false;
    }
    saveFun(){
        this.$emit("onSaveRemark",this.value);
        this.show = false;
    }
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/stock/components/remarkPanel.vue